<template>
  <v-scale-transition>
      <v-card v-show="value" class="pa-2">
        <img :src="legendURL" alt="Leyenda">
      </v-card>
  </v-scale-transition>
</template>

<script>
import config from '@/config'

const geoserverURL = `${config.geoserver.geoserverURL}/wms`

export default {
  props: ['value', 'layout'],
  data() {
    return {
      defaultLayout: 'horizontal'
    }
  },
  computed: {
    raster() {
      return this.$store.getters.raster
    },

    legendURL() {
      if(!this.raster) {
        return
      }

      const fontColor = this.$store.getters.isDarkTheme ? '0xFFFFFF0' : '0x000000'

      const layout = this.layout || this.defaultLayout

      const fontSize = 8

      return `${geoserverURL}?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&LAYER=${this.raster.name}&transparent=true&LEGEND_OPTIONS=layout:${layout};grouplayout:${layout};fontSize:${fontSize};fontColor:${fontColor};fontStyle:bold;dpi:180;dx:10;`
    },
  }
}
</script>

<style>
  .custom-chart {
    font-family: 'Roboto';
  }
</style>



// WEBPACK FOOTER //
// raster-legend.vue?266f142e